import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=381adfd2&scoped=true"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"
import style0 from "./Signature.vue?vue&type=style&index=0&id=381adfd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381adfd2",
  null
  
)

export default component.exports